import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { getUser } from '../../actions/session';
import { GET_ALL_ACCOUNTS, INVOICE_DOWNLOAD_API, CREATE_RESTRICTION, INVOICE_LIST_API, INVOICE_AGENT_LIST_API, GET_AGENTS_LIST } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';
import { Notifications } from '../common/notification';
import { withRouter } from 'react-router';
import Select from 'react-select';
import Pagination from "react-js-pagination"
import { fmtDollar4, fmtMins } from '../common/formatters';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

const getLastBillingDate = () => {
    const today = moment().utc().startOf('day');
    const candidates = [];

    // Last Monday (or today if Monday)
    if (today.day() === 1) {
        candidates.push(today.clone());
    } else {
        candidates.push(today.clone().subtract((today.day() + 6) % 7, 'days'));
    }

    // 15th of current month if on or before today
    const fifteenth = today.clone().startOf('month').date(15);
    if (fifteenth.isSameOrBefore(today)) {
        candidates.push(fifteenth);
    }
    // 15th of previous month
    candidates.push(today.clone().subtract(1, 'month').startOf('month').date(15));

    // Last day of previous month
    candidates.push(today.clone().subtract(1, 'month').endOf('month').startOf('day'));

    // Last day of current month if today is that day
    const lastDayThisMonth = today.clone().endOf('month').startOf('day');
    if (lastDayThisMonth.isSameOrBefore(today)) {
        candidates.push(lastDayThisMonth);
    }

    // Return the most recent one
    let mostRecent = candidates[0];
    candidates.forEach((d) => {
        if (d.isSameOrBefore(today) && d.isAfter(mostRecent)) {
            mostRecent = d;
        }
    });
    return mostRecent;
};

const AgentInvoiceTable = (props) => {

    const strDate = getLastBillingDate().toDate();
    const enDate = moment().utc().startOf('day').toDate();

    const [tableData, setTableData] = useState([])
    const [userInfo] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [isExpire, setisExpire] = useState(false)
    const [startDate, setStartDate] = useState(strDate)
    const [endDate, setEndDate] = useState(enDate)
    const [accountOption, setAccountOption] = useState([])
    const [accountSelect, setAccountSelect] = useState('')
    const [isChecked, setisChecked] = useState(true)
    const [activePages, setActivePages] = useState(1)
    const [totalCount, setTotalCount] = useState(null)
    const [itemCounts, setItemCounts] = useState({ label: '10', value: 10 })
    const [countList] = useState([
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: 'All', value: 400 },
    ])
    const [isBtnSpin, setisBtnSpin] = useState(false);

    useEffect(() => {
        getInvoiceList()
        getAccountList()
    }, [activePages])

    useEffect(() => {
        getInvoiceList()
        setisBtnSpin(false)
    }, [itemCounts])

    const handleDate = (date, value) => {
        if (value == "start") {
            setStartDate(date)
        } else {
            setEndDate(date)
        }
    }

    const handleSelectPagination = (itemCounts) => {
        setItemCounts(itemCounts)
    }

    const handleChecked = () => {
        setisChecked(!isChecked)
    }


    const handleAccountSelect = (accountSelect) => {
        setAccountSelect(accountSelect)
    }

    const getAccountList = () => {
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(GET_AGENTS_LIST, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                console.log(`resp`, resp)
                let getOption = resp.map((row) => {
                    row['label'] = row['name']
                    row['value'] = row['id']
                    return row
                })
                setAccountOption(getOption)
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
        })
    }

    const handlePageNumber = (pageNumber) => {
        setActivePages(pageNumber)
    }

    const getInvoiceList = () => {
        let User = userInfo
        console.log(`User`, User)
        var headers = { "Authorization": "Bearer " + User.token };
        var payload = {
            // "startDate": startDate.toLocaleString(),
            // "endDate": endDate.toLocaleString()
            "startDate": moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
            "endDate": moment(endDate).format('MM/DD/YYYY, h:mm:ss A')
        }
        let accountId = accountSelect === null ? undefined : accountSelect.value
        setIsGetting(true)
        setisBtnSpin(true)
        Axios.post(`${INVOICE_AGENT_LIST_API}?agentID=${accountId}&excludeZero=${isChecked ? 'yes' : 'no'}&page=${activePages}&search=&limit=${itemCounts.value}`, payload, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                console.log(`resp`, res)
                setTableData(resp)
                setIsGetting(false)
                setisBtnSpin(false)
                setTotalCount(res.data.pageinfo.totalCount)
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                setisExpire(true)
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN);
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setIsGetting(false)
            setisBtnSpin(false)

        })
    }

    const onDonwload = (data) => {
        // http://207.38.67.31:8080/invoice/6101874631813750e8e9b44d-000001.pdf  --- reference
        // http://207.38.67.31:8080/apiv1/invoice/61c1d30580ed4535d6a261d8-6101874631813750e8e9b44d-000001.pdf  --- reference
        const invoiceName = data.invoiceName
        const url = `${INVOICE_DOWNLOAD_API}/${invoiceName}`
        window.open(url, '_blank')

    }

    const renderTableData = () => {
        if (tableData === null || tableData.length === 0) {
            return (
                <div className=" ml-3">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return tableData.map((row, idx) => {
                return (<tr key={idx}>
                    <td>{row['agentName']}</td>
                    <td>{row['createDate']}</td>
                    <td>{row['frequency']}</td>
                    <td>{row['dateRange']}</td>
                    <td>{row['reportNumber']}</td>
                    <td style={{textAlign:'right'}}>{fmtMins(row['minutes'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['billedAmount'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['commission'])}</td>
                    <td>{row['commissionPlan']}</td>
                    <td><button type="button" class="btn btn-outline-dark btn-icon border-2 ml-2" onClick={onDonwload.bind(this, row)} ><i class={'icon-file-pdf'}></i></button></td>
                </tr>)
            })
        }
    }


    return (
        <div>
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body" >
            <div className="card-header header-elements-inline p-0 py-1 mb-2">
                    <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"> </h5>
                    <div className="header-elements">
                        <div className="" style={{ width: '9em' }}>
                        <Select
                            value={itemCounts}
                            onChange={handleSelectPagination}
                            options={countList}
                            placeholder="Select item count"
                        />
                        </div>
                    </div>
            </div>
            {/* heading */}
                <div className="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2 ">
                    <div class="py-2 px-3 mb-1">
                        <label className="fs-14">Start Date<span className="text-muted "> UTC Time-zone</span> </label>
                        <div class="input-group">
                        <DateRangePicker
                                    onCallback={(date) => handleDate(date, "start")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY',
                                    },
                                    }}
                                >
                                <input  type="text" className="form-control" style={{ minWidth: '220px' }} />
                                </DateRangePicker>
                            {/* <DatePicker
                                selected={startDate}
                                onChange={date => handleDate(date, "start")}
                                className="reporting-theme-date w-100"
                                maxDate={new Date()}
                                includeTimes={[
                                    setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
                                ]}
                                showTimeSelect
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm:ss aa"
                                isClearable
                                placeholderText="Add date"
                            >
                            </DatePicker> */}
                        </div>
                    </div>
                    <div class="py-2 px-3 mb-1">
                        <label className="fs-14">End Date<span className="text-muted "> UTC Time-zone</span> </label>
                        <div class="input-group">
                        <DateRangePicker
                                    onCallback={(date) => handleDate(date, "end")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY',
                                    },
                                    }}
                                >
                                <input type="text" className="form-control" style={{ minWidth: '220px' }} />
                                </DateRangePicker>
                            {/* <DatePicker
                                name="end"
                                selected={endDate}
                                onChange={date => handleDate(date, "end")}
                                className="reporting-theme-date w-100"
                                maxDate={new Date()}
                                includeTimes={[
                                    setHours(setMinutes(setSeconds(new Date(), 59), 59), 11),
                                ]}
                                showTimeSelect
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm:ss aa"
                                isClearable
                                placeholderText="Add date"
                            >
                            </DatePicker> */}
                        </div>
                    </div>
                    <div className='py-2 px-3 mb-1'>
                        <label className="fs-14">Agent</label>
                        <div className="w-20em">
                            <Select
                                value={accountSelect}
                                onChange={handleAccountSelect}
                                options={accountOption}
                                isClearable
                                placeholder="Select Agent"
                            />
                        </div>
                    </div>
                        <div className='py-2 px-3 mb-1'>
                                <label class="custom-control  custom-checkbox mt-4">
                                    <input type="checkbox" class="custom-control-input" onChange={handleChecked} checked={isChecked} />
                                    <span class="custom-control-label">Exclude $0.00</span>
                                </label>
                        </div>
                </div>
                {/* row1 */}
                <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                        <button type="submit" className="btn btn-success btn-sm main-button " onClick={getInvoiceList} >Generate <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i></button>
                        </div>
                </div>
                <div className="">
                    <div className="table-responsive "  style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "56em",
              }}>
                        <table className="table-style table table-striped  dataTable no-footer">
                            <thead>
                                <tr className="stickeyHeader table-heading-style">
                                    <th>Agent Name</th>
                                    <th>Create Date</th>
                                    <th>Frequency</th>
                                    <th>Date Range</th>
                                    <th>Report Number</th>
                                    <th style={{textAlign:'right'}}>Minutes</th>
                                    <th style={{textAlign:'right'}}>Billed Amount</th>
                                    <th style={{textAlign:'right'}}>Commission</th>
                                    <th>Commission Plan</th>
                                    <th>Download Report</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isGetting ? <CustomLoader /> : renderTableData()}
                            </tbody>
                        </table>
                    </div>
                    <div className="datatable-footer">
                        <div className="mt-3 text-center">
                            <Pagination
                                activePage={activePages}
                                itemsCountPerPage={itemCounts.value}
                                totalItemsCount={totalCount}
                                pageRangeDisplayed={5}
                                onChange={handlePageNumber}
                            />
                        </div>
                        {/* <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 1 to {tableLength} of {tableLength}</div> */}
                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(AgentInvoiceTable)